import { motion, useMotionValue } from 'motion/react';
import React, { useEffect } from 'react';
import { tryhardLogoPath } from '../../../svg/SVGData';
import { animate } from 'motion';

const TryhardNavLogo: React.FC<any> = () => {
    const scaleX = useMotionValue(1);
    // const scaleY = useMotionValue(1);
    const y = useMotionValue('0%');
    const rotateY = useMotionValue('0deg');


    const bounce = () => {
        const resetDuration = .1;
        const animationDuration = .9;
        const totalDuration = resetDuration + animationDuration;
        const times = [0, resetDuration, totalDuration]

        const transition = { duration: totalDuration, times }
        animate(y, ['0%', '-25%', '0%'], transition);
        animate(scaleX, [1.5, .75, 1], transition);
        animate(rotateY, ['0deg', `${4 * 360}deg`, '0deg'], {...transition, ease: 'easeOut'})
    }

    const onMouseEnter = () => {
        bounce();
    }

    useEffect(() => {
        bounce();
    }, [])

    return (
        <motion.svg
            exit={{ rotateY: `${6 * 360}deg`, y: '-25%', transition: { duration: 1, ease: 'easeOut' } }}
            style={{ 
                y, scaleX, rotateY ,
                filter: 'drop-shadow(0px 4px 8px rgba(0, 0, 0, .25))' 
            }}
            className='h-6 lg:h-10 min-w-max min-h-max'
            onHoverStart={onMouseEnter}
            fill={'red'}
            viewBox="0 0 100 138" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d={tryhardLogoPath} />
        </motion.svg>
    )
}

export default TryhardNavLogo;